import React from 'react';
import Shipment from './Shipment';
import { useShipmentSubscription } from './hooks/useShipment';
import { getIdParam } from './helpers';
const ShipmentDetailsContainer = (props) => {
    const shipmentId = getIdParam(props);
    useShipmentSubscription({ shipmentId });
    return React.createElement(Shipment, Object.assign({}, props));
};
export default ShipmentDetailsContainer;
